import React from "react";

const detailsbox = () => {
  return (
    <section className="detailsbox">
      <div className="details_box_inner text-start">
        <h5>Transaction details</h5>

        <ul className="p-0 m-0 details_list">
          <li>
            <p>You send</p>
            <p>
              <strong>150 USD</strong>
            </p>
          </li>


          <li>
            <p>Payment Method</p>
            <p>
              <strong>Visa / Mastercard</strong>
            </p>
          </li>


          <li>
            <p>Processing fee</p>
            <p>
              <strong>9.03 USD</strong>
            </p>
          </li>

          <li>
            <p>You get</p>
            <p>
              <strong>~ 0.07027 ETH</strong>
            </p>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default detailsbox;
